import { parse, stringify } from 'zipson'
import CryptoJS from 'crypto-js'

const ENCRYPTION_KEY = import.meta.env.VITE_ENCRYPTION_KEY

export interface TempSaveData {
  id: string
  path: string
  ed_idx: number
  created_at: string
  status: 'pending_payment' | 'completed' | 'expired'
  form_data: any
  expires_at: string
}

export interface appState {
  user: {
    UM_ID: string
    UM_IDX: string
    UM_NM: string
    UM_OAUTH_CD: string
    UM_FLAG: string
    UM_POWER: string
    POINT: number
    ACCESS_TOKEN: string
    REFRESH_TOKEN: string
    JADOO_TOKEN: string
  }
  tempSaveData: TempSaveData[]
}

export const useAppStore = defineStore('jadoo', {
  state: (): appState => ({
    user: {
      UM_ID: '',
      UM_IDX: '',
      UM_NM: '',
      UM_OAUTH_CD: '',
      UM_FLAG: '',
      UM_POWER: '',
      POINT: 0,
      ACCESS_TOKEN: '',
      REFRESH_TOKEN: '',
      JADOO_TOKEN: '',
    },
    tempSaveData: [],
  }),
  actions: {},
  persist: {
    key: 'jadoo',
    storage: persistedState.localStorage,
    serializer: {
      deserialize: (value: string) => {
        try {
          // 암호화된 데이터 복호화
          const bytes = CryptoJS.AES.decrypt(value, ENCRYPTION_KEY)
          const decryptedData = bytes.toString(CryptoJS.enc.Utf8)
          return parse(decryptedData)
        } catch (error) {
          console.error('스토어 복호화 중 오류 발생:', error)
          return null
        }
      },
      serialize: (value: any) => {
        // 데이터 암호화
        const serializedData = stringify(value)
        return CryptoJS.AES.encrypt(serializedData, ENCRYPTION_KEY).toString()
      },
    },
  },
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useAppStore, import.meta.hot))
}
